export default function NightIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1092_1949)">
        <path
          d="M18 15.9999C12.5 15.9999 8 11.4999 8 5.9999C8 5.0999 8.1 4.1999 8.4 3.3999C4.1 4.4999 1 8.3999 1 12.9999C1 18.4999 5.5 22.9999 11 22.9999C15.6 22.9999 19.5 19.8999 20.6 15.5999C19.8 15.8999 18.9 15.9999 18 15.9999Z"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 1V5"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 3H17"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 7V11"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 9H23"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1092_1949">
          <rect width="24" height="24" fill="inherit" />
        </clipPath>
      </defs>
    </svg>
  )
}
